module.exports = __webpack_public_path__ + "img/whatsapp-instruction-3.6c3c870c.png";